import './globals'

$('#top-drawer').on('show.bs.collapse', function () {
    if (_menuOpen) {
        $('body').removeClass('fancybox-active compensate-for-scrollbar');
        $('.menu-overlay').fadeOut();
        $('.menu').removeClass('active');
        _menuOpen = false;
    }
})

$('#top-drawer').on('shown.bs.collapse', function () {
    $("html, body").animate({
        scrollTop: 0
    }, "slow");
})